<template>
  <div class="pwdChange">
    <div class="title">设置管理员手机号</div>
    <van-form>
      <van-field name="手机号" label="手机号" placeholder="请输入" v-model="dataForm.mobile" required
                 :rules="[{ required: true, message: '请输入手机号' }]" clearable></van-field>
      <van-field name="短信验证码" label="短信验证码" placeholder="请输入" v-model="dataForm.code" required
                 :rules="[{ required: true, message: '请输入短信验证码' }]">
        <template #button>
          <van-button v-if="isCode" size="small" type="info" @click="getCode" style="border: none">发送验证码</van-button>
          <div v-else class="btnSendText">{{num}}</div>
        </template>
      </van-field>
      <div style="position:relative;">
        <van-button class="btn" round type="info" @click="changePwd">确认</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dataForm: {
        mobile: '',
        code: '',
      },
      num: 60,
      isCode: true,
      timer: null
    }
  },
  methods: {
    changePwd () {
      if (this.dataForm.mobile.trim() === '') {return this.$toast.fail('请输入手机号')}
      if (this.dataForm.code.trim() === '') {return this.$toast.fail('请输入验证码')}
      this.$router.push('./changeSuccess')
      // this.$http({
      //   url: this.$http.adornUrl('/wxapp/user/updateMobile'),
      //   method: 'post',
      //   params: this.$http.adornParams({
      //     newMobile: this.dataForm.newMobile,
      //     oldMobile: this.dataForm.oldMobile,
      //     code: this.dataForm.code
      //   },false)
      // }).then(({data}) => {
      //   if (data.code == 0) {
      //     this.$toast.success('修改成功')
      //     this.$router.go(-1)
      //   } else {
      //     this.$toast.fail(data.times ? data.msg + `,您还有${3 - data.times}次机会` : data.msg)
      //   }
      // })
    },
    getCode () {
      if (this.dataForm.mobile.trim() === '') {return this.$toast.fail('请输入手机号')}
      if (this.isCode) {
        this.isCode = false
        // this.$http({
        //   url: 'https://api.hzuht.com/general/verify/sendVerifyCode',
        //   method: 'post',
        //   headers: {token: this.$globalData.topToken},
        //   params: this.$http.adornParams({
        //     mobile: this.dataForm.newMobile
        //   },false)
        // }).then(({data}) => {
        //   if (data.code == 0) {
            this.$toast.success('发送成功')
        //   } else {
        //     this.$toast.fail(data.msg)
        //   }
        // })
        this.timer = setInterval(() => {
          this.num--
          if (this.num === 0) {
            this.isCode = true
            clearInterval(this.timer)
            this.num = 60
          }
        }, 1000)
      }
    }
  }
}
</script>
<style scoped>
.title {
  height: 96px;
  background: #FFFFFF;
  font-size: 32px;
  font-family: 'PingFangSC-Semibold';
  font-weight: 600;
  color: #333333;
  line-height: 96px;
  padding: 0 30px;
}
.pwdChange >>> .van-field__control {
  text-align: left !important;
}
.pwdChange >>> .van-button--default {
  border: none !important;
}
.btn {
  border-radius: 8px;
  width: 690px;
  position: absolute;
  left: 50%;
  top: 200px;
  transform: translateX(-50%);
}
</style>
